/**
 * Route definitions for the Dashboard module.
 * Lazily loads the main dashboard page (home page after login).
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const DashboardRoutes = createFeatureRoutes(
  'dashboard',
  {
    main: () => import('../presentation')
  },
  [{ path: '', pageKey: 'main' }]
);

export default DashboardRoutes;
